<template>
    <div class="uploadPic">
        <van-field v-if="item.type =='file'" :required='item.require ==1' class="filed">
            <template #label>
                <div class="picBox">
                    <span>{{item.label}}</span>
                </div>
            </template>
            <template #input>
                <div>
                    <div class="picBox">
                        <div class="list" v-for="(itm,idx) in preImages" :key="idx">
                            <img :src="itm" class="img" @click="show('preImages',idx)" />
                            <img :src="iconClear" class="clear" @click="delImg(idx)" v-if="item.readonly!=1" />
                        </div>
                        <div class="list" v-for="(itm,idx) in images" :key="idx">
                            <img :src="itm" class="img" @click="show('images',idx)" />
                            <img :src="iconClear" class="clear" @click="clear(itm,idx)" />
                        </div>
                        <template v-if="filetype && filetype != 'image'">
                            <van-uploader v-if="item.readonly!=1" v-model="files" :before-read="beforeRead" :max-count="item.upload_filecount" upload-icon="add" :accept="getFileType(filetype)" preview-size="52"/>
                        </template>
                        <template v-else>
                            <div class="add" @click="chooseImage()" v-if="showAdd &&item.readonly!=1">
                                <img src="/static/upload.png" />
                                <span>添加</span>
                            </div>
                        </template>
                        
                        
                    </div>
                    <div class="remarks">
                        <div>{{item.placeholder}}</div>
                        <div>请上传{{filetype}}文件，文件大小须小于{{item.upload_maxsize}}M</div>
                    </div>
                </div>
            </template>
        </van-field>
        <van-field v-if="item.type =='file' && item.sample_image" class="filed" label="示例图片">
            <template #input>
                <van-image width="80" height="80" :src="item.sample_image" fit="contain" @click="preview(item.sample_image)" />
            </template>
        </van-field>
    </div>
</template>

<script>
    import iconClear from "@/assets/docpc/clear.png"
    import {
        DownloadImage,
        UploadFile,
        deleteImg,
    } from '@/api/api'
    import {
        Toast,
        Dialog,
        ImagePreview
    } from "vant";
    import {
        mapActions,
        mapState
    } from 'vuex';

    export default {
        name: '',
        components: {
        },
        data() {
            return {
                iconClear: iconClear,
                images: [],
                preImages: [],
                baseFileUrl: this.baseUrl,
                filetype: '',
                files: [],
                maxsize: 0,
            }
        },
        props: ['item', 'value'],
        computed: {
            showAdd() {
                return parseInt(this.item.upload_filecount) > (this.images.length + this.preImages.length)
            },
        },
        mounted() {
            if (this.item.upload_filetype && this.item.upload_filetype !== 'image') {
                this.files = this.item.value
            } else {
                this.preImages = this.item.value
            }
            this.filetype = this.item.upload_filetype
            this.maxsize = parseInt(this.item.upload_maxsize) * 1048576
        },
        methods: {
            getFileType(val) {
                if (val == 'word') {
                    return '.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document'
                } else if (val == 'ppt') {
                    return '.ppt,.pptx,application/vnd.ms-powerpoint'
                } else if (val == 'pdf') {
                    return '.pdf,application/pdf'
                } else {
                    return 'image/*'
                }
            },
            checkFileType(ext) {
                if (this.filetype == 'word') {
                    return ['doc','docx'].indexOf(ext) != -1 ? true : false
                } else if (this.filetype == 'ppt') {
                    return ['ppt','pptx'].indexOf(ext) != -1 ? true : false
                } else if (this.filetype == 'pdf') {
                    return ['pdf'].indexOf(ext) != -1 ? true : false
                } else {
                    return true
                }
            },
            preview(file) {
                let images = []
                images.push(file)
                this.$nextTick(() => {
                    ImagePreview(images);
                })
            },
            show(status, index) {
                let idx
                if (status == 'images') {
                    idx = this.preImages.length + index
                } else {
                    idx = index
                }
                let images = this.preImages.concat(this.images)
                this.$nextTick(() => {
                    ImagePreview({
                        images,
                        startPosition: idx
                    });
                })
            },
            delImg(index) {
                Dialog.confirm({
                        message: '确定删除？',
                    })
                    .then(() => {
                        deleteImg({
                            attach_name: this.item.name,
                            attach_index: index,
                        }).then(res => {
                            Toast('删除成功')
                            this.preImages.splice(index, 1)
                            let list = this.preImages.concat(this.images)
                            this.item.value = list
                        }).catch(err => {
                            Toast(err.response.data.message)
                        })
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            },
            chooseImage() {
                let num = parseInt(this.item.upload_filecount) - this.preImages.length
                this.$wechat.chooseImage({
                    count: num>9?9:num,
                    // sizeType: ["compressed"], // 可以指定是原图还是压缩图，默认二者都有
                    sourceType: ["album", "camera"], // 可以指定来源是相册还是相机，默认二者都有
                    success: async res => {
                        try {
                            for(let i in res.localIds) {
                                const serverId = res.localIds[i];
                                await this.uploadImage(serverId);
                            }
                        } catch (err) {
                            console.log(err, 'err')
                            Toast(err.response.data.message);
                        }
                    },
                    fail: function () {
                        Toast("选图失败");
                    }
                });
            },
            uploadImage(serverId) {
                return new Promise((resolve, reject) => {
                    this.$wechat.uploadImage({
                        localId: serverId,
                        isShowProgressTips: 1,
                        success: (res) => {
                            var serverId = res.serverId; // 返回图片的服务器端ID
                            this.isLoading = true
                            DownloadImage({
                                    params: {
                                        serverId: serverId
                                    }
                                }).then((res) => {
                                    this.images.push(this.baseFileUrl + res)
                                    let list = this.preImages.concat(this.images)
                                    this.item.value = list
                                    this.isLoading = false
                                    resolve()
                                })
                                .catch((err) => {
                                    //  reject(err.response.data.message)
                                    console.log(err)
                                    this.isLoading = false
                                    reject(err)
                                })
                        }
                    });
                });
            },
            clear(item, index) {
                Dialog.confirm({
                        message: '确定删除？',
                    })
                    .then(() => {
                        this.images.splice(index, 1)
                        let list = this.preImages.concat(this.images)
                        this.item.value = list
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            },
            beforeRead(file) {
                let formData = new window.FormData()
                formData.append('file', file)
                if (file.size > this.maxsize) {
                    Toast({
                        duration: 1500,
                        forbidClick: true,
                        message: '上传失败，文件大小超过上传限制！',
                    });
                    return
                }
                this.$nextTick(()=>{
                    UploadFile(formData).then((res) => {
                        if (this.checkFileType(res.extension)) {
                            this.files.push(res.file_path)
                            this.item.value = this.files
                        } else{
                            Toast({
                                duration: 1500,
                                forbidClick: true,
                                message: '上传失败，文件类型错误！',
                            });
                        }
                    })
                    .catch((err) => {
                        Toast(err.response.data.message)
                        console.log('err',err)
                    })
                })
            },
        }
    }
</script>

<style lang="scss">
    .uploadPic {
        position: relative;

        .picBox {
            width: 100%;
            display: flex;
            justify-content: flex-start;
            flex-wrap: wrap;

            .list {
                height: 50px;
                width: 50px;
                margin-right: 10px;
                margin-bottom: 5px;
                position: relative;

                .img {
                    height: 100%;
                    width: 100%;
                }

                .clear {
                    position: absolute;
                    right: -2px;
                    top: -2px;
                    height: 13px;
                    width: 13px;

                }
            }

            .add {
                height: 50px;
                width: 50px;
                display: flex;
                align-items: center;
                flex-direction: column;
                justify-content: center;
                font-size: 12px;
                color: #272727;
                border: 1px dashed #272727;

                img {
                    height: 22px;
                    width: 22px;
                    margin-bottom: 2px;
                }

                span {
                    line-height: 12px;
                }
            }
        }

        .remarks {
            font-size: 12px;
            line-height: 1.4;
            color: #969799;
            margin-top: 5px;
        }
        .van-field__control .remarks { margin-top: 5px; }
        .preview-cover {
    position: absolute;
    bottom: 0;
    box-sizing: border-box;
    width: 100%;
    padding: 4px;
    color: #fff;
    font-size: 12px;
    text-align: center;
    background: rgba(0, 0, 0, 0.3);
  }

    }

    .uploadPic::after {
        position: absolute;
        box-sizing: border-box;
        content: ' ';
        pointer-events: none;
        right: 16px;
        bottom: 0;
        left: 16px;
        border-bottom: 1px solid #ebedf0;
        -webkit-transform: scaleY(.5);
        transform: scaleY(.5);
    }
</style>